import { stateAbstract, actionsAbstract, mutationsAbstract } from '@/store/abstract'

const state = {
  formsDetail: {},
  // temp persistent state
  selectedAddons: [],
  selectedPlans: [],
  // end temp persistent state
  signupsDetail: {},
  sourcesDetail: {},
  subscriptionsDetail: {},
  ...stateAbstract
}

const actions = {
  RESET_SIGNUP_FORMS: ({ commit }) => {
    commit('RESET_SIGNUP_FORMS')
  },
  RESET_SELECTED_PRODUCTS: ({ commit }) => {
    commit('RESET_SELECTED_PRODUCTS')
  },
  SET_SELECTED_PRODUCTS: ({ commit }, { selectedAddons, selectedPlans }) => {
    console.log(selectedAddons)
    console.log(selectedPlans)

    const addons = selectedAddons.map(a => {
      return { id: a.id, quantity: a.quantity }
    })
    const plans = selectedPlans.map(p => {
      return { id: p.id, quantity: p.quantity }
    })

    commit('SET_SELECTED_PRODUCTS', { addons, plans })
  },
  ...actionsAbstract
}

const mutations = {
  RESET_SIGNUP_FORMS: (state) => {
    state.selectedAddons = []
    state.selectedPlans = []
    state.signupsDetail = {}
    state.sourcesDetail = {}
  },
  RESET_SELECTED_PRODUCTS: (state) => {
    state.selectedAddons = []
    state.selectedPlans = []
  },
  SET_SELECTED_PRODUCTS: (state, { addons, plans }) => {
    state.selectedAddons = addons
    state.selectedPlans = plans
  },
  ...mutationsAbstract
}

export default {
  namespaced: true,
  state,
  actions,
  mutations
}
